import { useParams, useOutletContext } from "react-router-dom";

/**
 * Resolves the active academy slug for student-area pages.
 *
 * - On the platform host (dwrrah.com), URLs include `:slug` and React Router
 *   exposes it via `useParams().slug`.
 * - On a custom academy domain (e.g. `dwrrah.saasmain.com`), URLs have no
 *   `:slug` segment. The slug is resolved from the host by `CustomDomainShell`
 *   and forwarded through `AcademySlugShell` into the Outlet context as
 *   `auth.academy.slug`.
 *
 * Always returns a string (possibly empty) — never `undefined` — so consumers
 * can safely interpolate into URLs without producing `/undefined/...`.
 */
export default function useAcademySlug() {
  const params = useParams();
  let ctx = null;
  try {
    ctx = useOutletContext();
  } catch {
    ctx = null;
  }
  const fromCtx = ctx?.academy?.slug || ctx?.academySlug || "";
  return params?.slug || fromCtx || "";
}